import { DOMAINS, IMPORTANCE, SECTIONS } from '@repo/monitoring';
import { Practitioner, User } from '@repo/types';
import { UseSuspenseQueryOptions } from '@tanstack/react-query';
import { createServerFn } from '@tanstack/react-start';
import { API } from '~/api';

export interface PartnerUsersData {
  admin_user: User;
  practitioners: Practitioner[];
}

export const getAllUsers = createServerFn({ method: 'GET' }).handler(
  async (): Promise<PartnerUsersData> => {
    const response: PartnerUsersData = await API.get(
      '/api/partners/users',
      {},
      true,
      undefined,
      {
        tags: {
          section: SECTIONS.USERS,
          domain: DOMAINS.PARTNERS,
          importance: IMPORTANCE.HIGH,
        },
        context: {},
      },
    );
    return response;
  },
);

export const usersQueryOptions = (): UseSuspenseQueryOptions<
  PartnerUsersData,
  Error
> => ({
  queryKey: ['users'] as const,
  queryFn: async () => (await getAllUsers()) ?? [],
});
